import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableSortLabel,
  TableHead,
  TableRow,
  Button,
  IconButton,
} from '@mui/material';
import { Edit, Add } from '@mui/icons-material';
import { stableSort, compareByNumericProp } from '../../utils/comparators';
import { beginEditingUser, beginNewUser } from '../../redux/actions/users';

import './users-table.css';

const UsersTable = ({ userData, beginEditing, newUser, editingId, editType, scrollTop }) => {
  const [{ order, orderBy }, setSort] = useState({ orderBy: 'org_name', order: 'asc' });
  const comparator = compareByNumericProp(orderBy, order);
  const createSortHandler = (sortColumn) => () => {
    // first click on a column sort label sorts it by 'ascending' regardless of last order
    const isAsc = order === 'asc' && orderBy === sortColumn;
    setSort({ orderBy: sortColumn, order: isAsc ? 'desc' : 'asc' });
  };
  const sortLabel = (key, text) => {
    const isSort = orderBy === key;
    return (
      <TableSortLabel
        active={isSort}
        direction={isSort ? order : 'asc'}
        onClick={createSortHandler(key)}
      >
        {text}
      </TableSortLabel>
    );
  };
  return (
    <div className="user-table">
      <div className="new-user">
        <Button variant="contained" color="primary" onClick={() => newUser()}>
          <Add />
          Create new User
        </Button>
      </div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Edit</TableCell>
            <TableCell>{sortLabel('email', 'Email')}</TableCell>
            <TableCell>{sortLabel('last_name', 'Name')}</TableCell>
            <TableCell>{sortLabel('org_name', 'Organization')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {stableSort(userData, comparator).map((user) => (
            <TableRow
              className={`user-row ${!user.active ? 'inactive' : ''}`}
              key={user.id}
              hover
              selected={editType === 'USER' && editingId === user.id}
              classes={{ selected: 'selected' }}
            >
              <TableCell>
                <IconButton
                  onClick={() => {
                    scrollTop();
                    beginEditing(user.id);
                  }}
                  size="large"
                >
                  <Edit />
                </IconButton>
              </TableCell>
              <TableCell>
                <span className="email">{user.email}</span>
              </TableCell>
              <TableCell>
                {user.first_name} {user.last_name}
              </TableCell>
              <TableCell>{user.org_name}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default connect(
  ({
    users: {
      users,
      editing: { editType, id },
    },
  }) => ({
    userData: users || [],
    editType,
    editingId: id,
  }),
  (dispatch) => ({
    beginEditing: (id) => dispatch(beginEditingUser(id)),
    newUser: () => dispatch(beginNewUser()),
  })
)(UsersTable);
